import { Repository } from "@/forms/api/repository-factory";
import getParams from "@/forms/helpers/get-params";
import { EMAILNOTIFICATION } from "@/forms/constants/services";

const resource = "/onboarding-v2/deposit/emailnotification/v1.0";

export default {
  emailNotification(payload) {
    return Repository.post(`${resource}`, payload, {
      params: getParams(EMAILNOTIFICATION)
    });
  }
};
